import { useState } from 'react'
import { createPortal } from 'react-dom'

import { isEmptyObject, getIsTouchDevice } from 'utils'

import { AnimatePresence } from 'framer-motion'

import * as Styled from './styled'
import { useTooltipData } from './hooks/use-tooltip-data'
import { ARROW_SQUARE_WIDTH } from './consts'
import { ITooltipBaseProps, ITooltipContentProps } from './types'

const framerMotionProps = (isOpacityEnabled: boolean) => ({
  initial: { opacity: 0 },
  animate: { opacity: isOpacityEnabled ? 1 : 0 },
  exit: { opacity: 0, transition: { duration: 0 } }
})

const TooltipContent: React.FC<ITooltipContentProps> = props => {
  const {
    btnElement,
    tooltipText,
    tooltipPosition = 'top',
    scrollableParentRef = null,
    maxWidth,
    showMobileTooltip = false,
    textAlign = 'left',
    type = 'default',
    isToggledByClick = false
  } = props

  const [tooltipWrapperRef, setTooltipWrapperRef] =
    useState<HTMLDivElement | null>(null)

  const { isVisible, position, arrowStyles } = useTooltipData({
    btnElement,
    scrollableParentRef,
    type,
    showMobileTooltip,
    tooltipPosition,
    tooltipWrapperRef,
    isToggledByClick
  })

  const isOpacityEnabled =
    isVisible &&
    !!tooltipWrapperRef &&
    !isEmptyObject(arrowStyles as Record<string, unknown>)
  return createPortal(
    <AnimatePresence>
      {isVisible && (
        <Styled.TooltipWrapper
          {...framerMotionProps(isOpacityEnabled)}
          ref={setTooltipWrapperRef}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            event.stopPropagation()
          }}
          $position={position}
          $maxWidth={maxWidth}
          $textAlign={textAlign}
        >
          <Styled.TooltipArrow
            style={arrowStyles}
            $borderWidth={ARROW_SQUARE_WIDTH}
          />
          {tooltipText}
        </Styled.TooltipWrapper>
      )}
    </AnimatePresence>,
    document.getElementsByTagName('body')[0]
  )
}

const AdvancedTooltip = (props: ITooltipBaseProps) => {
  const isTouchDevice = getIsTouchDevice()
  const btnElement = props.btnRef?.current
  if (!btnElement) {
    return null
  }

  if (isTouchDevice && !props.showMobileTooltip) {
    return null
  }

  return <TooltipContent {...props} btnElement={btnElement} />
}
export default AdvancedTooltip
